
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { BaseMessageInfo } from '../models/BaseMessageInfo';

@Injectable()
export class EquipmentService extends BaseService {

    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl + "Equipment/";
    }
    getEquipFieldData(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetEquipFieldData/" + id
        return super.get(url_call);
    }
    getEquipmentParts(id: string): Observable<BaseMessageInfo> {
        let url_call: string = this.baseUrl + "GetEquipmentParts/" + id
        return super.get(url_call);
    }
    getByCustomerOrLocation(customerId: string, id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetByCustomerOrLocation/" + customerId + "/" + id;
        return super.get(url_call);
    }
    getEquipmentByLocation(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetEquipmentByLocation/" + id
        return super.get(url_call);
    }

}

